import Login from "../pages/Login/Login";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import Support from "./../pages/Support/Support";
import Home from "../pages/Home/Home";
import About from "../components/About/About";
import Features from "../pages/Features/Features";
import Process from "../pages/Process/Process";
import ContactUsPublic from "../pages/ContactUsPublic/ContactUsPublic";
import { RoutesE } from "./routesData";
import RedirectToLogin from "./RedirectToLogin";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import ShareVideo from "../pages/ShareVideo/ShareVideo";
import ShareVideoAd from "../pages/ShareVideoAd/ShareVideoAd";
import Test from "../pages/Test/Test";
import Registration from "../pages/Registration/Registration";

// uses when there is no user logged in

export const publicRoutes = [
  // landing page
  { path: RoutesE.HOME, element: <Home /> },
  { path: RoutesE.ABOUT, element: <About /> },
  { path: RoutesE.FEATURES, element: <Features /> },
  { path: RoutesE.PROCESS, element: <Process /> },
  { path: RoutesE.CONTACT_US, element: <ContactUsPublic /> },

  // authorization section
  { path: RoutesE.LOGIN, element: <Login /> },
  { path: RoutesE.REGISTRATION, element: <Registration /> },
  { path: RoutesE.FORGOT_PASSWORD, element: <ForgotPassword /> },
  { path: RoutesE.RESET_PASSWORD, element: <ResetPassword /> },
  { path: RoutesE.SUPPORT, element: <Support /> },

  // default — preserves the intended destination as ?returnUrl= for after login
  { path: RoutesE.DEFAULT, element: <RedirectToLogin /> },

  // login by token
  {
    path: RoutesE.PROJECT_SHARED_AD,
    element: <ShareVideoAd />,
  },
  {
    path: RoutesE.PROJECT_SHARED,
    element: <ShareVideo />,
  },
  {
    path: RoutesE.TEST,
    element: <Test />,
  },
];
